// extracted by mini-css-extract-plugin
export default {"cta":"cH-z","disabled":"dH-z"};